import { Box, Card, Skeleton } from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import useResponsive from "../../../components/hooks/useResponsive";
import { ListDivider } from "../../../ui/ListStyles";
import { styled } from "@mui/material/styles";
import { List } from "@mui/icons-material";

const roiPeriodData = [
  { label: "هفتگی" },
  { label: "ماهانه" },
  { label: "سه ماهه" },
  { label: "شش ماهه" },
  { label: "سالانه" },
  { label: "سه ساله" },
];

const RoiIndustriesSkeleton = () => {
  const { isMd } = useResponsive();

  const Typography = styled("p")({
    fontSize: "12px",
  });

  const Row = styled("div")({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  });

  return (
    <Grid2 container spacing={"14px"}>
      {Array.from({ length: isMd ? 24 : 4 }).map((_, i) => (
        <Grid2 key={i} xs={12} sm={6} md={4} lg={3} xl={1.5}>
          <Card
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
            }}
          >
            <Skeleton variant="text" width={"100%"} />

            <ListDivider flexItem />

            <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              {roiPeriodData.map((data, i) => (
                <Row key={i}>
                  <Typography>{data.label}</Typography>
                  <Skeleton variant="rounded" width={30} />
                </Row>
              ))}
            </Box>

            <button className="btn" style={{ fontWeight: 400 }} disabled>سهم‌ها</button>
          </Card>
        </Grid2>
      ))}
    </Grid2>
  );
};

export default RoiIndustriesSkeleton;
